<template>
  <div class="mod-rm__coursevehiclerela">
    <el-card shadow="never" class="aui-card--fill">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" label-position="left"
        label-width="90px">
        <el-row :gutter="10">
          <!-- 第一行 -->
          <el-col :span="7">
            <!-- 用户ID -->
            <el-form-item :label="$t('user.userID')">
              <el-input v-model="dataForm.userCode" clearable :placeholder="$t('user.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 姓名 -->
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName" clearable :placeholder="$t('user.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 公司名称 -->
            <el-form-item :label="$t('user.companyDistributor')">
              <el-select v-model="dataForm.orgId" filterable collapse-tags remote clearable reserve-keyword
                :placeholder="$t('user.input')" :remote-method="querySearch">
                <el-option v-for="item in results" :key="item.orgId" :label="item.name" :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" class="query-button">
            <el-col :span="24">
              <el-button class="M-search" style="margin-bottom: 7px" type="primary" @click="queryCourse()">{{
                $t('trainer.query') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <!-- 第二行 -->
          <el-col :span="7">
            <!-- 组织类型 -->
            <el-form-item v-if="showOrg != 1" :label="$t('organization.orgType')" prop="orgType">
              <el-select v-model="dataForm.orgType" clearable :placeholder="$t('user.select')">
                <el-option v-for="(item, index) in neworgType" :key="index" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else></el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item></el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item></el-form-item>
          </el-col>
          <el-col :span="3" class="query-button">
            <el-col :span="24">
              <el-button class="M-search" style="margin-bottom: 7px" type="info" @click="resetQueryData()">{{
                $t('trainer.reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div class="search">
        <!-- 确定按钮 -->
        <el-button style="margin-bottom: 7px" type="primary" @click="useronOk">{{ $t('trainer.define') }}</el-button>
      </div>

      <div class="selectRadioClass">
        <el-table :data="dataList" @select="selectRedio" border stripe class="jySelectionAll" v-loading="dataListLoading"
          ref="coursePlanTable" style="width: 100%;">
          <el-table-column header-align="center" type="selection" align="center" width="50">
          </el-table-column>
          <!-- 序号 -->
          <el-table-column prop="userId" header-align="center" align="center" v-if="false" :label="ID">
          </el-table-column>
          <!-- 用户ID -->
          <el-table-column prop="userCode" :label="$t('user.userID')" width="130" show-overflow-tooltip align="left"
            class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 员工号 -->
          <el-table-column prop="userCardNo" :label="$t('trainer.userCardNo')" width="130" show-overflow-tooltip
            align="left" class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 用户名 -->
          <el-table-column prop="userName" :label="$t('user.name')" width="120" show-overflow-tooltip align="left" fixed
            class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 组织类型 -->
          <el-table-column prop="orgType" :label="$t('organization.orgType')" :formatter="orgFormatter" width="230"
            show-overflow-tooltip align="left" class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 所属公司 -->
          <el-table-column prop="abbreviation" :label="$t('user.GWMcompany')" width="230" show-overflow-tooltip
            align="left" class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 部门 -->
          <el-table-column prop="bmwDeptCode" header-align="center" align="center" show-overflow-tooltip
            :label="$t('trainer.departments')">
          </el-table-column>
          <!-- 加入该职位时间 -->
          <el-table-column prop="orgJoinDate" :label="$t('user.accessionDate')" :formatter="openDateFormatter" width="140"
            show-overflow-tooltip align="center" header-align="center">
          </el-table-column>
          <!-- 邮箱 -->
          <el-table-column prop="email" :label="$t('trainer.mail')" width="180" show-overflow-tooltip align="left"
            class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 手机号 -->
          <el-table-column prop="mobile" :label="$t('trainer.phone')" width="130" show-overflow-tooltip align="left"
            class-name="tableleft" label-class-name="tablelabel" header-align="center">
          </el-table-column>
          <!-- 出生日期(未) -->
          <el-table-column prop="email" header-align="center" align="center" v-if="false" show-overflow-tooltip
            :label="$t('user.mail')">
          </el-table-column>
          <!-- 性别(未) -->
          <el-table-column prop="sexCode" header-align="center" align="center" width="80" v-if="false"
            :label="$t('trainer.sex')">
          </el-table-column>
          <!-- 性别 -->
          <el-table-column prop="sexCode" header-align="center" :formatter="sexFormatter" align="center"
            show-overflow-tooltip :label="$t('trainer.sex')">
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="pageSizeChangeHandle" @current-change="pageCurrentChangeHandle" :current-page="page"
        :page-sizes="[10, 20, 50, 100]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import ClassTree from '@/components/rm/class-tree/index'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  props: {
    showOrg: {
      type: Number | String,
    },
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commuser/list',
        getDataListIsPage: true
      },
      // 公司list
      results: [],
      sexType: this.enums['sex'],
      // 组织类型
      userorgType: this.enums['orgType'],
      // 组织类型
      neworgType: [],
      dataForm: {
        courseNo: '',
        coursecName: '',
        classcName: '',
        teamName: '',
        teamClassList: [],
        orgTypeList: [],
        jobStatus: this.showOrg == 1 ? '' : '10',
        registrationApprovaStatus: '50',
        orgType: this.showOrg == 1 ? '60' : null,
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTreeUrl: '/rm/rpc/treamClassTree/list'
    }
  },
  components: {
    'class-tree': ClassTree
  },
  mounted() {
    this.neworgType = JSON.parse(JSON.stringify(this.userorgType))
    if (this.neworgType.length === 6) {
      // this.neworgType.splice(3, 2)
      this.neworgType.splice(4, 1)
    }
    this.page = 1
    this.getDataList()
  },
  methods: {
    gotoView(type, id) {
      let query = {}
      let name = 'rm-coursevehiclerela-add-or-update'
      query.courseVehicleRelaId = id
      if (type === 'view') {
        name = 'rm-coursevehiclerela-view'
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'update') {
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'delete') {
        this.deleteHandle(id)
      }
    },
    useronOk() {
      let select = this.$refs.coursePlanTable.selection
      if (select.length <= 0) {
        this.$message.warning(this.$t('trainer.select'))
        return false
      }
      let _this = this
      _this.$request.get(`/rm/trainer/queryUserInt`, { userCode: select[0].userCode }).then((res, total, code, data) => {
        if (data.data > 0 && _this.showOrg != 1) {
          _this.$message({
            message: _this.$t('trainer.selectUserCode'),
            type: 'failed'
          })
          return false
        }
        _this.$emit('useronOk', select[0])
        _this.$refs.coursePlanTable.clearSelection()
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 单选
    selectRedio: function selectRedio(selection, row) {
      if (this.$refs.coursePlanTable.selection.length > 1) {
        this.$refs.coursePlanTable.clearSelection()
        this.$refs.coursePlanTable.toggleRowSelection(row)
      }
    },
    getSelectList(args) {
      let teamClass = []
      args.forEach(function (item) {
        teamClass.push(item.id)
      })
      this.dataForm.teamClassList = teamClass
    },
    // 重置查询条件
    resetQueryData() {
      console.log(this.showOrg, "this.showOrg")
      this.dataForm = {
        courseNo: '',
        coursecName: '',
        classcName: '',
        teamName: '',
        teamClassList: [],
        orgTypeList: [],
        // jobStatus: '10',
        registrationApprovaStatus: '50',
        orgType: null,
      }
      if (this.showOrg != 1) {
        this.dataForm.orgType = ''
        this.dataForm.jobStatus = '10'
      } else {
        this.dataForm.orgType = '60'
        this.dataForm.jobStatus = ''
      }
      console.log('1231231231')
      this.page = 1
      this.getDataList()
    },
    queryCourse() {
      this.page = 1
      this.getDataList()
    },
    // 获取公司信息
    querySearch(queryString) {
      this.$request.get('/sys/org/selectOrg', { name: queryString }).then((res, total, code, data) => {
        this.results = res
        this.results = this.results.map(item => {
          item['value'] = item.name
          return item
        })
      })
    },
    sexFormatter(row) {
      // 性别
      return Vue.filter('coverEnum')(row.sexCode, 'sex')
    },
    orgFormatter(row) {
      // 组织类型
      return Vue.filter('coverEnum')(row.orgType, 'orgType')
    },
    // 入职日期
    openDateFormatter(row) {
      if (row.orgJoinDate !== '' && row.orgJoinDate !== null) {
        return Vue.filter('formatDateNoTime')(row.orgJoinDate)
      } else {
        return ''
      }
    }
  }
}
</script>
<style>
/* 隐藏网格的全选按钮 */
.jySelectionAll>.el-table__header-wrapper>.el-table__header>thead>tr>th>.cell>label {
  display: none !important;
}

.selectRadioClass thead .el-table-column--selection .cell {
  display: none !important;
}
</style>
